import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CaseDashboardRoutingModule } from './case-dashboard-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MaterialprimeModule } from '../shared/material.module';
import { HttpLoaderFactory } from '../shared/shared.module';
import { ActiveCaseComponent } from './active-case/active-case.component';
import { CaseHistoryComponent } from './casehistory/casehistory.component';
import { MyCasesComponent } from './my-cases/my-cases.component';
import { HeaderComponent } from './header/header.component';
import { CasedialogComponent } from './casedialog/casedialog.component';
import { CasefilterdialogComponent } from './casefilterdialog/casefilterdialog.component';
import { SettingsComponent } from './settings/settings.component';
import { AuditlogdateComponent } from './auditlogdate/auditlogdate.component';
import { EditduedatedialogComponent } from './editduedatedialog/editduedatedialog.component';
import { LocaltimezonePipe } from '@shared/pipe/localtimezone.pipe';


@NgModule({
  declarations: [
    ActiveCaseComponent,
    CaseHistoryComponent,
    MyCasesComponent,
    HeaderComponent,
    CasedialogComponent,
    CasefilterdialogComponent,
    SettingsComponent,
    AuditlogdateComponent,
    EditduedatedialogComponent,
    LocaltimezonePipe
  ],
  imports: [
    CommonModule,
    MaterialprimeModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    CaseDashboardRoutingModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CaseDashboardModule { }
